import { render, staticRenderFns } from "./SlidingPages.vue?vue&type=template&id=76cd9390&scoped=true"
import script from "./SlidingPages.vue?vue&type=script&lang=js"
export * from "./SlidingPages.vue?vue&type=script&lang=js"
import style0 from "./SlidingPages.vue?vue&type=style&index=0&id=76cd9390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cd9390",
  null
  
)

export default component.exports